import React from 'react'
import { Script } from 'gatsby'

const ActiveCampaign = ({ slice }) => {
  return (
    <section className='component-activeCampaign mx-auto max-w-screen-xl p-6'>
      <div className={slice.primary.form_class || `_form_${slice.primary.form_id}`} />
      <Script id='activeCampaign' src={`https://apex-group.activehosted.com/f/embed.php?id=${slice.primary.form_id}`} />
    </section>
  )
}

export default ActiveCampaign
